<template>
  <div class="play-plan-config">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('cAdvertPiano.editPiano')"
      :visible.sync="showPianoDialog"
      width="1150px"
      top="9vh"
      :close-on-click-modal="false"
      @open="handleOpen"
      @close="cancel"
    >
      <div>
        <el-form :model="formData" :rules="rules" label-position="top" ref="formRef" hide-required-asterisk>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item :label="$t('cAdvertPiano.putIn')" prop="playNum">
                <el-input :placeholder="$t('desktop.launchNum')" v-model="formData.playNum" type="number">
                  <template slot="append">{{ $t("cAdvertPiano.numByDay") }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('cAdvertPiano.promozioneDate')" prop="playTime">
                <el-date-picker
                  v-model="formData.playTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :start-placeholder="$t('components.Insert.9398966-57')"
                  :end-placeholder="$t('components.Insert.9398966-58')"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('cAdvertPiano.weekTip')">
                <AdvertWeek v-model="formData.config.time" ref="weekRef" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="color: brown">{{ $t("cAdvertPiano.tip") }}</div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="submitForm">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import AdvertWeek from "@/components/adverts/AdvertWeek.vue";

  export default {
    name: "PlayPlanConfig",
    props: {
      showPianoDialog: {
        type: Boolean,
        default: false
      },
      advertGroupId: {
        type: String,
        default: ""
      }
    },
    components: {
      AdvertWeek
    },
    data() {
      return {
        formData: {
          id: "",
          playNum: 0,
          playTime: null,
          config: {
            time: []
          }
        },
        rules: {
          playNum: [
            {
              required: true,
              message: this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.putIn")]),
              trigger: "blur"
            }
          ]
        }
      };
    },
    methods: {
      async handleOpen() {
        if (!this.advertGroupId) return;
        const res = await this.$api.request("/adTeam/plan/getById", this.$method.get, { id: this.advertGroupId });
        if (res.code === 0) {
          const detail = res.data;
          this.formData = {
            id: detail.id,
            playNum: detail.playNum || 0,
            playTime: detail.startDate && detail.endDate ? [detail.startDate, detail.endDate] : null,
            config: detail.config || { time: [] }
          };
          if (!this.formData.config.time) {
            this.formData.config.time = [];
          }
          if (this.formData.config.time.length === 0) {
            this.$nextTick(() => {
              this.$refs.weekRef?.onToggleAll(true);
            });
          }
        }
      },
      cancel() {
        this.formData = {
          id: "",
          playNum: 0,
          playTime: null,
          config: {
            time: []
          }
        };
        this.$refs.formRef?.resetFields();
        this.$emit("update:showPianoDialog", false);
      },
      async submitForm() {
        const that = this;
        await this.$refs.formRef?.validate(async isValid => {
          if (isValid) {
            if (this.formData.config?.time?.length == 0) {
              that.$message({
                message: that.$t("cAdvertPiano.weekTip"),
                type: "warning"
              });
              return;
            }
            const params = {
              id: this.formData.id,
              playNum: this.formData.playNum ? Number(this.formData.playNum) : 0,
              startDate: null,
              endDate: null,
              config: {
                time: this.formData.config?.time || []
              }
            };

            if (this.formData.playTime && this.formData.playTime.length === 2) {
              params.startDate = this.formData.playTime[0];
              params.endDate = this.formData.playTime[1];
            }
            if (this.formData.config?.time?.length === 168) {
              params.config.time = [];
            }
            const res = await this.$api.request("/adTeam/plan/config", this.$method.put, params);
            if (res.code === 0) {
              this.$message({
                message: this.$t("common.success"),
                type: "success"
              });
              this.$emit("success");
              this.cancel();
            }
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .dialog-footer {
    text-align: right;
  }
</style>
